/**
 * The app's one React Query client. In its own module so AuthContext can empty
 * it on sign-out (TRUS-638): cached query results are member data, and a
 * window that signs out must not keep them in memory.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
